// Recovered compiled webpack factory 55287. Edit this function expression; run npm run build.
(e, t, r) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      getSortedRouteObjects: function () {
        return n.getSortedRouteObjects;
      },
      getSortedRoutes: function () {
        return n.getSortedRoutes;
      },
      isDynamicRoute: function () {
        return a.isDynamicRoute;
      },
    }));
  let n = r(44761),
    a = r(72421);
}
